export default function About() {
  return (
    <section
      className="about padding-top padding-bottom bg--primary-color"
      id="about"
    >
      <div className="container">
        <div className="section-header section-header--middle">
          <div className="section-header__content">
            <div className="section-header__titlebar">
              <p className="section-header__subtitle"> Intro</p>
              <h2 className="section__header__title pb-2">Quantum Energy</h2>
              <p className="pb-2">
                The ERC-20 token with a built-in automated airdrop system. Holders can stake tokens or provide liquidity to receive rewards in additional QTE tokens. Unlike other tokens, we do not require you to lock your tokens away for months or penalize you for unstaking. You can stake and unstake at any time.
              </p>
              <p>
                <span className="inline-block p-3">
                  <a
                    className="default-btn default-btn pr-3"
                    href="https://app.uniswap.org/#/swap?outputCurrency=0xe89a194d366a3f18b06ced6474dc7daba66efa83"
                    target="_blank"
                    alt="Buy on Uniswap"
                  >
                    Buy QTE
                  </a>
                </span>
                <span className="inline-block p-3">
                  <a
                    href="https://etherscan.io/token/0xe89A194D366A3f18B06Ced6474DC7dAba66EFa83"
                    target="_blank"
                    className="default-btn default-btn"
                    alt="Contract on Etherscan"
                  >
                    Contract
                  </a>
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
